'use strict'

const home = {
    path: '',
    name:'home',
	meta: {
		  title: '秀川结算中心-综合服务平台',
		  name:'首页',
		  code:''
	},
    component: () => import('@/pages/home/StatisticsHome'),
};




export default home;